// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__8D0Vc","CardModal":"Card_CardModal__u0Zn8","animatedCard":"Card_animatedCard__QmRSA"};